import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CountdownTime, timeHelpers } from '@mzima-client/sdk';
import { interval, map, Observable, shareReplay, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent {
  public timeLeft$: Observable<CountdownTime>;
  private stopTimer$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  @Input() public deadline: Date = new Date();
  @Output() countdownFinished = new EventEmitter<void>();

  constructor() {
    this.timeLeft$ = interval(1000).pipe(
      map(() => {
        const timeLeft = timeHelpers.calculateDateDifference(this.deadline);

        if (
          timeLeft.daysLeft <= 0 &&
          timeLeft.hoursLeft <= 0 &&
          timeLeft.minutesLeft <= 0 &&
          timeLeft.secondsLeft <= 0 // timer stops at 00:00
        ) {
          this.stopTimer$.next();
          this.stopTimer$.complete();
          this.countdownFinished.emit();
        }

        return timeLeft;
      }),
      takeUntil(this.stopTimer$),
      takeUntil(this.destroy$),
      shareReplay(1),
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
